import React, { useState } from 'react';
import * as Constants from './constants';
import { Link } from '@amzn/awsui-components-console';

/**
 * get time from millseconds to a date
 * @return {String} date string
 */
export function getTimeInDate(time) {
    const date = time ? new Date(parseInt(time)).toUTCString() : '';
    return date;
}

/**
 * get test run result
 * @param {*} testRun
 */
export function getTestResult(testrun) {
    try {
        if (testrun[Constants.TEST_RUN_TYPE] === Constants.KATS_TEST_RUN_TYPE) {
            const testRunDetail = testrun[Constants.TEST_RUN_DETAIL];
            const testRunId = testRunDetail['kats']['id'];
            return (
                <Link external href={`https://scheduler.dots.lab126.a2z.com/scheduling/testruns/${testRunId}/files`}>
                    {' '}
                    {testRunId}{' '}
                </Link>
            );
        } else {
            return '';
        }
    } catch (err) {
        console.error(`get test run result for ${testrun} failed with`, err);
        return '';
    }
}

/**
 * get test run type name
 * @param {*} type
 */
export function getTestTypeName(type) {
    return type ? Constants.TEST_RUNT_TYPE_MAPPING[type] || '' : '';
}

/**
 * get test run scheduled timeout in min
 * @param {*} timeout
 */
export function getTimeoutInMin(timeout) {
    return timeout ? Math.round(parseInt(timeout) / 60) || '' : '';
}

/**
 * get test run suite name
 * @param {*} testrun
 */
export function getTestSuite(testrun) {
    try {
        if (testrun[Constants.TEST_RUN_TYPE] === Constants.KATS_TEST_RUN_TYPE) {
            const testRunDetail = testrun[Constants.TEST_RUN_DETAIL];
            return testRunDetail['kats']['testSuite'];
        } else {
            return '';
        }
    } catch (err) {
        console.error(`get test suite for ${testrun} failed with`, err);
        return '';
    }
}
